export default __webpack_public_path__ + "static/media/logo-webapp.04c48a3a.svg";